import { _notNil } from '@/littledash';
import type { ID } from '@/model/Common.model';

interface IsRegisteringOnBehalfProps {
  owner: ID;
}
export const isRegisteringOnBehalf = (owner: IsRegisteringOnBehalfProps) => _notNil(owner);
